export default "__VITE_ASSET__DS1__GK4__"